import { useQuery } from '@tanstack/react-query';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';
import { AttendanceCheckApi } from 'api/ApiHelper';

export const useGetAttendanceCheckQuery = (yearMonth: string) =>
  useQuery({
    queryKey: activityPointQueryKey.attendanceCheck(yearMonth),
    queryFn: () => AttendanceCheckApi.findAttend(yearMonth),
  });
